import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { ErrorScreen } from "./ErrorScreen";
import { NotFoundPage } from "@/pages/not-found";

export function RouteErrorScreen() {
  const routeError = useRouteError();

  // Handle 404s from React Router
  if (isRouteErrorResponse(routeError) && routeError.status === 404) {
    return <NotFoundPage />;
  }

  // Convert route error to Error object
  const error =
    routeError instanceof Error
      ? routeError
      : new Error(
          isRouteErrorResponse(routeError)
            ? `${String(routeError.status)} ${routeError.statusText}`
            : String(routeError)
        );

  const statusCode = isRouteErrorResponse(routeError) ? routeError.status : undefined;

  return <ErrorScreen error={error} statusCode={statusCode} />;
}
